// extracted by css-extract-rspack-plugin
export default {"root":"vXegc","label":"fnJ5q","description":"Ysrub","icon":"KRNGg","radio":"XTmFw"};